import {BingMap} from './directives/bing-map';
import {BingMapMarker} from './directives/bing-map-marker';
import {BingMapInfoWindow} from './directives/bing-map-info-window';
import {BingMapInfoWindowAction} from './directives/bing-map-info-window-action';

export {BingMap} from './directives/bing-map';
export {BingMapMarker} from './directives/bing-map-marker';
export {BingMapInfoWindow} from './directives/bing-map-info-window';
export const NG2_BINGMAPS_DIRECTIVES: any[] =
    [BingMap, BingMapMarker, BingMapInfoWindow, BingMapInfoWindowAction];
